/**
 * sessionStorage key for package error recovery.
 * Only `@pcln/pkg-itinerary-bar` writes (write-once). Consumers read for error prepopulation.
 */
export const PKG_SEARCH_SESSION_RECOVERY_KEY = 'pkgSearchRecovery'
